import React from 'react'
import './services.css'
import { BiCheck } from 'react-icons/bi'

const Services = () => {
  return (
    <section id="services">
      <h5>What I Offer</h5>
      <h2>Services</h2>

      <div className="container services__container">
        <article className='service'>
          <div className="service__head">
            <h3>UI/UX Design</h3>
          </div>

          <ul className='service__list'>
            <li>
              <BiCheck className='service__list-icon' />
              <p>User research.</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>User Experience Design.</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Interface Design.</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Responsive Design.</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Usability Testing.</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Visual Testing And Collaboration.</p>
            </li>

          </ul>
        </article>
        {/* END OF UI/UX */}

        <article className='service'>
          <div className="service__head">
            <h3>Content Creation</h3>
          </div>

          <ul className='service__list'>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Blog Writing.</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Artical Writing</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Social Media Content Creation.</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Copy Writing and Content Content Creation.</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>E-Book Writing.</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Content editing and proofreading.</p>
            </li>


          </ul>
        </article>
        {/* END OF CONTENT CREATION */}





        <article className='service'>
          <div className="service__head">
            <h3>Web Development</h3>
          </div>

          <ul className='service__list'>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Website design and development.</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>E-commerce solutions.</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Content management systems (CMS).</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Website maintenance and updates.</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Search engine optimization (SEO).</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Website redesign.</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Web Hosting.</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Technical support.</p>
            </li>

          </ul>
        </article>
        {/* End of Web Development */}


      </div>
    </section>
  )
}

export default Services